import { CopyButton, SwitchAppButton } from "../../../../../components";
import { IViewGatewayTransferBeneficiary } from "../../../../../interfaces-and-types";
import { truncateStringWithEllipsis } from "../../../../../utils";

interface IGatewayBeneficiaryListItemProps {
  beneficiary: IViewGatewayTransferBeneficiary;
  selectBeneficiary: (ben: IViewGatewayTransferBeneficiary) => void;
}

export const GatewayBeneficiaryListItem = ({
  beneficiary,
  selectBeneficiary,
}: IGatewayBeneficiaryListItemProps) => (
  <div className="cds--structured-list-row" key={beneficiary.id}>
    <div className="cds--structured-list-td" title={beneficiary.id}>
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={beneficiary.id}>
            {truncateStringWithEllipsis(beneficiary.id, 5)}
          </span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            name="copy-beneficiary-id-button"
            stringToCopy={beneficiary.id}
            iconDescription="copy beneficiary id"
            className="copy-btn"
          />
        </div>
      </div>
    </div>

    <div className="cds--structured-list-td font-ctm--semibold ">
      {beneficiary.gateway_name}
    </div>

    <div className="cds--structured-list-td font-ctm--semibold text-teal">
      {beneficiary.full_name?.trim() || <>(No&nbsp;Alias)</>}
    </div>

    <div className="cds--structured-list-td font-ctm--semibold text-primary">
      {beneficiary.merchant_name}
    </div>

    <div className="cds--structured-list-td font-ctm--semibold text-primary">
      {beneficiary.merchant_id_or_code}
    </div>

    <div
      className="cds--structured-list-td"
      title="Select this beneficiary as recipient"
    >
      <SwitchAppButton
        // kind="danger"
        kind="secondary"
        onClick={() => selectBeneficiary(beneficiary)}
        size="sm"
        className="flex-box"
      >
        Select
      </SwitchAppButton>
    </div>
  </div>
);
